/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Chart as ChartJs, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { PropTypes } from 'prop-types';

ChartJs.register(ArcElement, Tooltip, Legend);

function DoughnutChart({ ChartOptions, chartData }) {
	return <Doughnut options={ChartOptions} data={chartData} />;
}

DoughnutChart.propTypes = {
	ChartOptions: PropTypes.any,
	chartData: PropTypes.any,
};

export default DoughnutChart;
